@use '@design/design-tokens/typography/typography' as *;

.styledInput {
  @include typography-v2-body-base;
}

.alert {
  margin-top: 16px;
  width: 100%;
}
